

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_Tabs";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_Tabs__root","text-medium-normal":"wds_1_130_0_StylableTypography__text-medium-normal","text-small-normal":"wds_1_130_0_StylableTypography__text-small-normal","container":"wds_1_130_0_Tabs__container","itemsContainer":"wds_1_130_0_Tabs__itemsContainer","tab":"wds_1_130_0_Tabs__tab","compact":"wds_1_130_0_Tabs__compact","uniformFull":"wds_1_130_0_Tabs__uniformFull","compactSide":"wds_1_130_0_Tabs__compactSide","tabText":"wds_1_130_0_Tabs__tabText","sideContent":"wds_1_130_0_Tabs__sideContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-400":"--wds-space-400","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-color-text-primary":"--wds-color-text-primary","wds-color-border-standard-primary-active":"--wds-color-border-standard-primary-active","wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-tabs-gap-medium":"--wds-tabs-gap-medium","wds-tabs-gap-small":"--wds-tabs-gap-small","wds-tabs-padding-horizontal-medium":"--wds-tabs-padding-horizontal-medium","wds-tabs-padding-horizontal-small":"--wds-tabs-padding-horizontal-small","wds-tabs-padding-vertical-medium":"--wds-tabs-padding-vertical-medium","wds-tabs-padding-vertical-small":"--wds-tabs-padding-vertical-small","wds-tabs-label-font-size-small":"--wds-tabs-label-font-size-small","wds-tabs-label-line-height-small":"--wds-tabs-label-line-height-small"}; 




